export const lang = {
  'appTitle': 'React Native GraphQL',
  'confirm': 'Confirm',
  'cancel': 'Cancel',
  'error': 'An error has occurred',
  'users': 'Users',
  'usersNone': '0 Users Found',
  'userCreate': 'Create User',
  'userCreated': 'User created successfully!',
  'userUnableCreate': 'Unable to create user',
  'userUpdate': 'Update User',
  'userUpdated': 'User updated successfully!',
  'userUnableUpdate': 'Unable to edit user',
  'userDelete': 'Delete User',
  'userDeleted': 'User deleted successfully!',
  'userDeleteConfirm': 'Are you sure you want to delete %{firstName} %{lastName}?',
  'userFirstName': 'First Name',
  'userLastName': 'Last Name',
  'userEmail': 'Email',
}
